import React, { Component } from "react";
import { message, DatePicker, Select } from "antd";
import { map, isEmpty } from "lodash";
import Script from "react-load-script";
import moment from "moment-timezone";
import * as yup from "yup";
import { CameraOutlined } from '@ant-design/icons';
import BasicDetail from "./BasicDetail";
import SideBar from "./SideBar";
import Header from "../../../Common/Component/Header";
import Sidebar from "../../../Common/Component/Sidebar";
import Loader from "../../../Common/Component/Loader";
import cross_icon from "../../../../Assets/images/cross_icon.svg";
import AllState from "../../../../Assets/data/stateList.json";
import ServiceInfo from "./ServiceInfo";
import {errorHandle} from "../../../Common/errorHandle";
import Axios from 'axios';
import config from '../../../../Lib/Config';
const { Option } = Select;

const communityRoleData = [
  {
    name: 'Board Member',
    value: 'board_member'
  },
  {
    name: 'Community Manager',
    value: 'community_manager'
  },
  {
    name: 'Concerned Resident',
    value: 'concerned_resident'
  },
];
const communityTypeData = [
  {
    name: 'Townhomes',
    value: 'townhomes'
  },
  {
    name: 'Detached Homes',
    value: 'detached'
  },
  {
    name: 'Condominium',
    value: 'condo'
  },
  {
    name: 'Apartment',
    value: 'apartment'
  },
];
const preferredContactData = [
  {
    name: 'Text',
    value: 'text'
  },
  {
    name: 'Home Phone',
    value: 'phone'
  },
  {
    name: 'Email',
    value: 'email'
  },
  {
    name: 'Office',
    value: 'office'
  },
];

class AddQuote extends Component {
  constructor(props) {
    super(props);
    this.state = {
      franchises: [],
      zipcode: '',
      zipcodeCheck: null,
      is_basic_btn_active: false,
      is_service_btn_active: false,
      is_btn_active: false,
      role: '',
      communityType: [],
      home_count: '',
      is_proposal: true,
      communityBoundaryMap: {},
      more_info: false,
      is_address_manually: false,
      address: {
        address: '',
        city: '',
        state: '',
        zip_code: '',
        route: '',
        street_number: ''
      },
      proposalDate: '',
      preferredContact: [],
      commercialData: {},
      isEdit: false,
      is_boundary_map: false,
      errors: {},
      zip_code: '',
      hear_about_us: []
    }
    this.upload = null;
    this.basicDetail = null;
    this.serviceInfo = null;
  }

  componentDidMount() {
    const { history } = this.props;
    const { zipcode } = this.state;
    const quoteDetail = history?.location?.state?.query?.quoteDetail;
    this.props.resetCheckZipcode()

    if (quoteDetail) {
      let url = quoteDetail?.community_boundary_map?.split('?') || [];
      let community_boundary_map_name = url?.[0]?.split('/')?.[url?.[0]?.split('/')?.length - 1]
      let type = community_boundary_map_name?.includes('.pdf') ? 'application/pdf' : '';
      let blob = new Blob(url)

      let obj = {
        role: quoteDetail?.role,
        communityType: quoteDetail?.properties_in_community || [],
        home_count: quoteDetail?.home_count,
        is_proposal: quoteDetail?.is_looking_for_proposal || true,
        communityBoundaryMap: quoteDetail?.community_boundary_map ? { uri: quoteDetail?.community_boundary_map, name: community_boundary_map_name, type, size: blob?.size } : {},
        more_info: quoteDetail?.would_like_more_info || false,
        is_address_manually: false,
        address: quoteDetail?.address ? quoteDetail?.address : {},
        proposalDate: quoteDetail?.proposal_due,
        preferredContact: quoteDetail?.reach_out_via || [],
        zipcode: zipcode ? zipcode : quoteDetail?.field_office?.zip_code,
        outreach: quoteDetail?.outreach
      }
      this.setState({ commercialData: quoteDetail, ...obj, isEdit: true }, () => {
        if (this.refs["address"]) {
          const { address } = this.state;
          let addressStr = address?.address ? `${address?.address}` : '';
          addressStr += address?.city ? `, ${address?.city}` : '';
          addressStr += address?.state ? `, ${address?.state}` : '';
          addressStr += address?.zip_code ? `, ${address?.zip_code}` : '';
          this.refs["address"].value = addressStr
        }
      })
    }
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    // message.destroy();
    //error handle
    if (Object.keys(nextProps?.ZipcodeCheck?.errors).length > 0 && nextProps?.ZipcodeCheck?.errors !== this.props?.ZipcodeCheck?.errors) {
      this.setState({loader: false});
      errorHandle(nextProps?.ZipcodeCheck?.errors)
    }

    if (Object.keys(nextProps?.CommercialProposal?.errors).length > 0 && nextProps?.CommercialProposal?.errors !== this.props?.CommercialProposal?.errors) {
      this.setState({loader: false});
      errorHandle(nextProps?.CommercialProposal?.errors)
    }

    ////////////////////////////////////////////////////

    // check zipcode
    if (Object.keys(nextProps?.ZipcodeCheck?.data).length > 0 && nextProps?.ZipcodeCheck?.data?.results?.length > 0) {
      this.setState({ zipcodeCheck: true, franchises: nextProps?.ZipcodeCheck?.data?.results });
    } else {
      this.setState({ zipcodeCheck: false, franchises: [] });
    }
    
    //add quote
    if (Object.keys(nextProps?.CommercialProposal?.addQuote).length > 0 &&
      JSON.stringify(nextProps?.CommercialProposal?.addQuote) !== JSON.stringify(this.props?.CommercialProposal?.addQuote)) {
      if (nextProps?.CommercialProposal?.addQuote?.uuid) {
        let obj = {
          // user_uuid: nextProps?.quote?.user_uuid,
          commercial_quote_uuid: nextProps?.CommercialProposal?.addQuote?.uuid,
          proposal_status: 'enquiry',
          proposal_date: nextProps?.CommercialProposal?.addQuote?.proposal_due ? moment(nextProps?.CommercialProposal?.addQuote?.proposal_due).format('YYYY-MM-DD') : null,
        }
        this.props.addCommercialProposal(obj)
      } else {
        message.error('Quote id not found', 10)
        this.setState({ loader: false });
      }
    }

    if (Object.keys(nextProps?.CommercialProposal?.addCommercialProposal)?.length > 0 &&
      JSON.stringify(nextProps?.CommercialProposal?.addCommercialProposal) !== JSON.stringify(this.props?.CommercialProposal?.addCommercialProposal)) {
      this.addInnerProposal(nextProps?.CommercialProposal?.addCommercialProposal)
    }
    
    //update quote
    if (Object.keys(nextProps?.CommercialProposal?.updateQuote).length > 0 &&
      JSON.stringify(nextProps?.CommercialProposal?.updateQuote) !== JSON.stringify(this.props?.CommercialProposal?.updateQuote)) {
      sessionStorage.removeItem('service_info')
      this.props.getQuoteById(this.state?.commercialData?.uuid)
      this.props.history.goBack()
    }
    // get geocode
    if (Object.keys(nextProps?.GoogleApi?.getGeocode) && JSON.stringify(nextProps?.GoogleApi?.getGeocode) !== JSON.stringify(this.props?.GoogleApi?.getGeocode)) {
      this.setAddress(nextProps?.GoogleApi?.getGeocode)
    }
    this.setState({ loader: false });
  }

  // add inner proposal
  addInnerProposal = (addCommercialProposal) => {
    this.setState({loader: true})
    const {service = {}, product = {}, serviceFrequency = ''} = JSON.parse(sessionStorage.getItem('service_info')) || {};
    const arr = [];
    const line_items = [];
    map(service, (item) => {
      let obj_item = {
        item_type: 'service',
        item: item,
        model: '',
        frequency: serviceFrequency,
        description: '',
        discount: '0',
        quantity: '0',
        rate: '0',
        rate_tax: '0',
        s_and_h: '0',
        s_and_h_tax: '0',
        total: '0',
        is_incomplete: true
      }
      line_items.push(obj_item)
    }) // end of inner proposal line items

    map(product, (item) => {
      let obj_item = {
        item_type: 'product',
        item: item,
        model: '',
        frequency: serviceFrequency,
        description: '',
        discount: '0',
        quantity: '0',
        rate: '0',
        rate_tax: '0',
        s_and_h: '0',
        s_and_h_tax: '0',
        total: '0',
        is_incomplete: true
      }
      line_items.push(obj_item)
    }) // end of inner proposal line items

    arr.push(
      this.props.addInnerCommercialProposal({
        proposal_uuid: addCommercialProposal?.uuid,
        line_items
      })
    )

    Promise.all(arr).then((response) => {
      if (!isEmpty(response)) {
        sessionStorage.removeItem('service_info')
        this.props.history.replace('/commercial')
      } else {message.error('Something went wrong.')}
    }).catch(() => {
      message.error('Something went wrong.')
    })
  }
  
  // on proposal detail change
  onTextChange = (e, type) => {
    const value = type === 'bool' ? e.target.checked : e.target.value;
    this.setState({ [e.target.name]: value }, () => this.storeInLocal())
  }

  onPreferredContactChanged = (value) => {
    const { preferredContact } = this.state;
    const idx = preferredContact?.indexOf(value);

    idx > -1 ? preferredContact.splice(idx, 1) : preferredContact.push(value);
    this.setState({ preferredContact }, () => this.storeInLocal())
  };

  onCommunityTypeChanged = (value) => {
    const { communityType } = this.state;
    const idx = communityType.indexOf(value);

    idx > -1 ? communityType.splice(idx, 1) : communityType.push(value);
    this.setState({ communityType }, () => this.storeInLocal())
  };

  // on address change
  onAddressChanged = (e) => {
    const { address } = this.state;
    Object.assign(address, { [e.target.name]: e.target.value });
    this.setState({ address }, () => this.storeInLocal());
  };

  // validate numeric input
  onNumericInputChange = (value) => {
    const reg = /^-?\d*(\.\d*)?$/;
    return ((!isNaN(value) && reg.test(value)) || value === '' || value === '-')
  };

  // get base 64 string
  getBase64String = (file = {}, cb) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = function () {
      cb(reader.result);
    }
  };

  // community map change
  onCommunityImageChange = (e) => {
    let file = e?.target?.files?.[0];
    if (file.type === 'application/pdf') {
      if (file?.size > (5 * 1048576)) {
        message.error('Image size should be less than 5MB');
      } else {
        file && this.getBase64String(file, (result) => {
          this.setState({
            'communityBoundaryMap': {name: file.name, size: file.size, uri: result, type: file.type},
            is_boundary_map: true
          }, () => this.storeInLocal())
        });
      }
    } else {message.error('Uploaded file is not a valid')}
  };

  // toggle loader
  toggleLoader = (value) => {
    if (value !== this.state.loader) {
      this.setState({ loader: value })
    }
  }

  // set all data
  setCommercialData = (data) => {
    const { commercialData } = this.state;
    if (JSON.stringify(commercialData) !== JSON.stringify(data)) {
      this.setState({ commercialData: { ...commercialData, ...data } })
    }
  }

  /**
   * AUTHOR: Ritesh Solanki
   * <DP-3393>CRM | Commercial | Proposal | User is not able to edit zipcode</DP-3393>
   */
  setZipCode = (zip_code) => {
    console.warn('zip_code', zip_code);
    this.setState({
      zip_code: zip_code
    });
  }

  storeInLocal = () => {
    const { role, communityType, home_count, is_proposal, communityBoundaryMap, more_info, address, proposalDate, preferredContact, is_boundary_map } = this.state;

    let obj = {
      role,
      reach_out_via: preferredContact,
      properties_in_community: communityType,
      home_count,
      community_boundary_map: communityBoundaryMap?.uri || '',
      community_boundary_map_name: communityBoundaryMap?.name || '',
      is_looking_for_proposal: is_proposal,
      proposal_due: proposalDate ? moment(proposalDate).format('YYYY-MM-DD') : null,
      would_like_more_info: more_info,
      address: (address?.street_number || address?.route) ? { ...address, address: `${address?.street_number || ''} ${address?.route || ''}` } : address,
      is_boundary_map
    }
    this.setCommercialData(obj)
  }

  // set address
  setAddress = (addressObject) => {
    if (!isEmpty(addressObject)) {
      if (addressObject?.status === "OK") {
        let obj = {}, components = addressObject?.results?.[0];
        map(components?.address_components, (item) => {
          if (item?.types?.includes('administrative_area_level_2')) {
            obj = Object.assign(obj, { 'address': item.short_name })
          }
          if (item?.types?.includes('route')) {
            obj = Object.assign(obj, { 'route': item.short_name })
          }
          if (item?.types?.includes('street_number')) {
            obj = Object.assign(obj, { 'street_number': item.short_name })
          }
          if (item?.types?.includes('administrative_area_level_1')) {
            obj = Object.assign(obj, { 'state': item.short_name })
          }
          if (item?.types?.includes('locality')) {
            obj = Object.assign(obj, { 'city': item.long_name })
          }
          if (item?.types?.includes('postal_code')) {
            obj = Object.assign(obj, { 'zip_code': item.short_name })
          }
        });
        this.setState({ address: obj }, () => {
          if (!obj?.address || !obj?.state || !obj.city || !obj.zip_code) {
            message.error('Please enter valid address')
          } else {this.storeInLocal()}
          // this.validate()
        });
      } else {
        message.error('Something went wrong while getting address')
      }
    }
  }

  // Google Map Place API
  handleScriptLoad = () => {

    // Declare Options For Autocomplete
    const options = { componentRestrictions: { country: 'us' } };

    // Initialize Google Autocomplete
    /*global google*/ // To disable any eslint 'google not defined' errors
    const newAutoComplete = new google.maps.places.Autocomplete(
      document.getElementById('google_address'),
      options,
    );

    // Avoid paying for data that you don't need by restricting the set of
    // place fields that are returned to just the address components and formatted
    // address.
    newAutoComplete.setFields(['address_components', 'formatted_address']);

    // Fire Event when a suggested name is selected
    newAutoComplete.addListener('place_changed', this.handlePlaceSelect);

    this.setState({
      autocomplete: newAutoComplete,
    })
  };
   removeEmpty=(obj) =>{
     return Object.fromEntries(Object.entries(obj).filter(([_, v]) => (v !== null && v?.trim() !== "")));
   }
  handlePlaceSelect = () => {
    const address= document?.getElementById('google_address')?.value;
    Axios.get(`https://maps.googleapis.com/maps/api/geocode/json`, {
      params: this.removeEmpty({
        latlng: undefined,
        address,
        key: process.env.REACT_APP_GOOGLE_PLACE_API_KEY,
      })
    }).then((res) => {
      const addressObject = res?.data?.results[0];
      let obj = {};
      map(addressObject?.address_components, (item) => {
        if (item?.types?.includes('route') || item?.types?.includes('administrative_area_level_2')) {
          obj = Object.assign(obj, { 'address': item.short_name })
        }
        if (item?.types?.includes('route')) {
          obj = Object.assign(obj, { 'route': item.long_name })
        }
        if (item?.types?.includes('street_number')) {
          obj = Object.assign(obj, { 'street_number': item.short_name })
        }
        if (item?.types?.includes('administrative_area_level_1')) {
          obj = Object.assign(obj, { 'state': item.short_name })
        }
        if (item?.types?.includes('locality')) {
          obj = Object.assign(obj, { 'city': item.long_name })
        }
        if (item?.types?.includes('postal_code')) {
          obj = Object.assign(obj, { 'zip_code': item.short_name })
        }
      });
      this.setState({ address: obj }, () => {
        if (!obj?.address || !obj?.state || !obj.city || !obj.zip_code) {
          message.error('Please enter valid address')
        } else {this.storeInLocal()}
      // this.validate()
      });
    }).catch((err) => {
      console.log(err)
    })
    // this.props.resetGeocodeAddress()
    // this.props.getGeocodeAddress({key: process.env.REACT_APP_GOOGLE_PLACE_API_KEY, address})
  }

  // validate required values
  validate = (action) => {
    // basic detail validation
    this.basicDetail.validate().then((res) => {
      if (res === 'success') {
        const { communityBoundaryMap, address, is_address_manually, zip_code } = this.state;
        const { ZipcodeCheck } = this.props;
        const isAddress = !!address?.address
        const FILE_SIZE = 5 * 1048576;
        const SUPPORTED_FORMATS = ["application/pdf"];

        const schema = yup.object().shape({
          communityBoundaryMap: yup.mixed().test("fileSize", "File too large", obj => {
            if (!isEmpty(obj)) return (obj.size <= FILE_SIZE)
            return true
          }).test("fileFormat", "Unsupported Format", obj => {
            if (!isEmpty(obj)) return (SUPPORTED_FORMATS.includes(obj.type))
            return true
          }),
          address: yup.object().shape({
            address: yup.string().test('match', 'address is required', (address) => {
              if (isAddress) return address
              return true
            }),
            city: yup.string().test('match', 'city is required', (city) => {
              if (isAddress) return city
              return true
            }),
            state: yup.string().test('match', 'state is required', (state) => {
              if (isAddress) return state
              return true
            }),
            zip_code: yup.string().test('match', 'zip code is required.', (zip_code) => {
              //if (isAddress) return zip_code === commercialData?.zipcode
              if (isAddress) return zip_code
              return true
            }),
          }),
        });

        const data = {
          communityBoundaryMap,
          address,
        }

        // Community info validation
        schema.validate(data, { abortEarly: false }).then(() => {
          this.setState({ is_btn_active: true, errors: {} });
          // service info validation
          this.serviceInfo.validate().then((service_res) => {
            if (is_address_manually) {
              if (action === 'save') this.onSubmit()
              else if (action === 'edit') this.onUpdate()
            } else {
              if (action === 'save') this.onSubmit()
              else if (action === 'edit') this.onUpdate()
              /*
              axios.post(`${config.getHost()}service-order/validate_address/`, {
                field_office_uuid: ZipcodeCheck?.data?.results[0]?.uuid,
                address: this.refs['address'].value
              }).then((response) => {
                if (Object.keys(response).length > 0 && response?.data?.is_valid) {
                  if (service_res === 'success') {
                    if (action === 'save') this.onSubmit()
                    else if (action === 'edit') this.onUpdate()
                  }
                }      
              }).catch((error) => {
                message.error('Sorry, we could not find that address in OptimoRoute. Please check the address and try again, or enter latitude/longitude coordinates.');
              });
              */
            }            
          })
        }).catch((error) => {
          let err_data = {};
          map(error?.inner, (item) => {err_data[item.path] = item.message})
          this.setState({errors: err_data, is_btn_active: false})
        }) // add quote validation end
      } // if end
    }) // basic validate end
  };

  // api call based on selection
  onSubmit = () => {
    
    const { commercialData, franchises, zip_code } = this.state;
    let idx = commercialData?.phone_numbers?.findIndex(x => x.primary === true)
    if (idx === -1) commercialData.phone_numbers[0].primary = true
    this.setState({ loader: true });

    map(commercialData?.phone_numbers, (obj) => {
      if(!obj.uuid) delete obj?.uuid
    })

    setTimeout(() => {
      let obj = {
        field_office_uuid: franchises?.[0]?.uuid || null,
        first_name: commercialData?.first_name,
        last_name: commercialData?.last_name,
        management_company: commercialData?.management_company,
        community_name: commercialData?.community_name || null,
        email_address: commercialData?.email_address,
        phone_numbers: commercialData?.phone_numbers,
        role: commercialData?.role,
        reach_out_via: commercialData?.reach_out_via,
        properties_in_community: commercialData?.properties_in_community,
        home_count: commercialData?.home_count,
        community_boundary_map: commercialData?.community_boundary_map || "",
        is_looking_for_proposal: commercialData?.is_looking_for_proposal || true,
        proposal_due: commercialData?.proposal_due || null,
        would_like_more_info: commercialData?.would_like_more_info || false,
        address: !isEmpty(commercialData?.address?.address) ? {
          address: commercialData?.address?.address,
          city: commercialData?.address?.city,
          state: commercialData?.address?.state,
          zip_code: commercialData?.address?.zip_code
        } : null,
        hear_about_us: commercialData?.hear_about_us,
        interested_products: commercialData?.interested_products, // step 2 data
        interested_services: commercialData?.interested_services,
        is_pet_waste_stations_installed: commercialData?.is_pet_waste_stations_installed || false,
        existing_pet_waste_stations_count: commercialData?.existing_pet_waste_stations_count || 0,
        new_pet_waste_stations_interested: commercialData?.new_pet_waste_stations_interested,
        bag_type: commercialData?.bag_type,
        areas_to_clean: commercialData?.areas_to_clean,
        is_trash_cans_installed: commercialData?.is_trash_cans_installed || false,
        trash_cans_count: commercialData?.trash_cans_count || 0,
        new_trash_cans_interested: commercialData?.new_trash_cans_interested,
        current_frequency: commercialData?.current_frequency,
        additional_comments: commercialData?.additional_comments || null,
        status: 'open',
        zip_code: zip_code,
        outreach: commercialData?.outreach
      }
      if (commercialData?.is_boundary_map && commercialData?.community_boundary_map) {
        const arr = commercialData?.community_boundary_map?.split(';')
        const community_boundary_map = arr[0] + `;df:${obj?.name?.replace('.pdf', '')};` + arr[1]
        Object.assign(obj, { community_boundary_map })
      }
      if (commercialData?.is_pet_img && commercialData?.pet_waste_station_map) {
        const arr = commercialData?.pet_waste_station_map?.split(';')
        const pet_waste_station_map = arr[0] + `;df:${obj?.name?.replace('.pdf', '')};` + arr[1]
        Object.assign(obj, { pet_waste_station_map })
      }
      if (commercialData?.is_clean_img && commercialData?.common_area_cleaning_map) {
        const arr = commercialData?.common_area_cleaning_map?.split(';')
        const common_area_cleaning_map = arr[0] + `;df:${obj?.name?.replace('.pdf', '')};` + arr[1]
        Object.assign(obj, { common_area_cleaning_map })
      }
      if (commercialData?.is_trash_img && commercialData?.trash_can_location_map) {
        const arr = commercialData?.trash_can_location_map?.split(';')
        const trash_can_location_map = arr[0] + `;df:${obj?.name?.replace('.pdf', '')};` + arr[1]
        Object.assign(obj, { trash_can_location_map })
      }
      this.props.addQuote(obj);
    }, 500)
  };

  // update based on selection
  onUpdate = () => {
    const { commercialData, franchises, zip_code } = this.state;
    this.setState({ loader: true });
    let idx = commercialData?.phone_numbers?.findIndex(x => x.primary ===   true)
    if (idx === -1) commercialData.phone_numbers[0].primary = true

    map(commercialData?.phone_numbers, (obj) => {
      if(obj.uuid) delete obj?.uuid
    })
    setTimeout(() => {
      let obj = {
        field_office_uuid: franchises?.[0]?.uuid || null,
        first_name: commercialData?.first_name,
        last_name: commercialData?.last_name,
        management_company: commercialData?.management_company,
        community_name: commercialData?.community_name || null,
        email_address: commercialData?.email_address,
        phone_numbers: commercialData?.phone_numbers,
        role: commercialData?.role,
        reach_out_via: commercialData?.reach_out_via,
        properties_in_community: commercialData?.properties_in_community,
        home_count: commercialData?.home_count,
        is_looking_for_proposal: commercialData?.is_looking_for_proposal || true,
        proposal_due: commercialData?.proposal_due || null,
        would_like_more_info: commercialData?.would_like_more_info || false,
        address: !isEmpty(commercialData?.address?.address) ? {
          address: commercialData?.address?.address,
          city: commercialData?.address?.city,
          state: commercialData?.address?.state,
          zip_code: commercialData?.address?.zip_code
        } : null,
        hear_about_us: commercialData?.hear_about_us,
        interested_products: commercialData?.interested_products, // step 2 data
        interested_services: commercialData?.interested_services,
        is_pet_waste_stations_installed: commercialData?.is_pet_waste_stations_installed || false,
        existing_pet_waste_stations_count: commercialData?.existing_pet_waste_stations_count || 0,
        new_pet_waste_stations_interested: commercialData?.new_pet_waste_stations_interested,
        bag_type: commercialData?.bag_type,
        areas_to_clean: commercialData?.areas_to_clean,
        is_trash_cans_installed: commercialData?.is_trash_cans_installed || false,
        trash_cans_count: commercialData?.trash_cans_count || 0,
        new_trash_cans_interested: commercialData?.new_trash_cans_interested,
        current_frequency: commercialData?.current_frequency,
        additional_comments: commercialData?.additional_comments || null,
        status: commercialData?.status,
        zip_code: zip_code
      }
      if (commercialData?.is_boundary_map) {
        const arr = commercialData?.community_boundary_map?.split(';')
        const community_boundary_map = arr[0] + `;df:${commercialData?.community_boundary_map_name?.replace('.pdf', '')};` + arr[1]
        Object.assign(obj, { community_boundary_map })
      }
      if (commercialData?.is_pet_img) {
        const arr = commercialData?.pet_waste_station_map?.split(';')
        const pet_waste_station_map = arr[0] + `;df:${commercialData?.pet_waste_station_map_name?.replace('.pdf', '')};` + arr[1]
        Object.assign(obj, { pet_waste_station_map })
      }
      if (commercialData?.is_clean_img) {
        const arr = commercialData?.common_area_cleaning_map?.split(';')
        const common_area_cleaning_map = arr[0] + `;df:${commercialData?.common_area_cleaning_map_name?.replace('.pdf', '')};` + arr[1]
        Object.assign(obj, { common_area_cleaning_map })
      }
      if (commercialData?.is_trash_img) {
        const arr = commercialData?.trash_can_location_map?.split(';')
        const trash_can_location_map = arr[0] + `;df:${commercialData?.trash_can_location_map_name?.replace('.pdf', '')};` + arr[1]
        Object.assign(obj, { trash_can_location_map })
      }

      this.props.updateQuote(commercialData?.uuid, obj);
    }, 500);
  };

  //render community role
  renderCommunityRole = (item, index) => {
    const { role, zipcodeCheck } = this.state;
    const isSelected = role === item.value;

    return (
      <div className="inline-checks" key={`role${index}`}>
        <label htmlFor={item?.value} className={isSelected ? 'active' : ''}>
          <input type="checkbox" id={item?.value} name="role" disabled={!zipcodeCheck} className="" value={item?.value} onChange={() => this.onTextChange({ target: { name: 'role', value: item?.value } })} />
          <span>{item?.name}</span>
        </label>
      </div>
    )
  };

  //render preferred contact
  renderPreferredContact = (item, index) => {
    const { preferredContact, zipcodeCheck } = this.state;
    const isSelected = preferredContact?.includes(item.value);

    return (
      <div className="inline-checks" key={`contact${index}`}>
        <label htmlFor={item?.value} className={isSelected ? 'active' : ''}>
          <input type="checkbox" id={item?.value} name="preferredContact" disabled={!zipcodeCheck} className="" value={item?.value} onChange={() => this.onPreferredContactChanged(item?.value)} />
          <span>{item?.name}</span>
        </label>
      </div>
    )
  };

  //render hear about us
  renderType = (item, index) => {
    const { communityType, zipcodeCheck } = this.state;
    const isSelected = communityType?.includes(item.value);

    return (
      <div className="inline-checks" key={`communityType${index}`}>
        <label htmlFor={item?.value} className={isSelected ? 'active' : ''}>
          <input type="checkbox" id={item?.value} name="communityType" disabled={!zipcodeCheck} className="" value={item?.value} onChange={() => this.onCommunityTypeChanged(item?.value)} />
          <span>{item?.name}</span>
        </label>
      </div>
    )
  };

  // render all state
  renderAllState = () => {
    return AllState.AllState.map((item, i) => {
      return (<Option value={item.abbreviation} key={i}>{item.name}</Option>)
    })
  }

  render() {
    const { zipcodeCheck, loader, home_count, is_proposal, is_address_manually,
      more_info, address, commercialData, communityBoundaryMap, proposalDate, isEdit, errors, is_btn_active } = this.state;

    return (
      <div id="wrapper">
        <div className="content-area">
          {/* Header */}
          <Header
            placeholder="Search for a ticket by client name, subject or keyword"
          />

          {/* Sidebar */}
          <Sidebar />
          <div className="fluid">
            {loader && <Loader />}
            <div className="container">
              <div className="fluid-block">
                <div className="article-block">
                  <BasicDetail
                    ref={(ref) => this.basicDetail = ref}
                    checkMail={this.props.checkMail}
                    CheckMailStatus={this.props.CheckMailStatus}
                    checkZipCode={this.props.checkZipCode}
                    zipcode={this.state.zipcode}
                    zipcodeCheck={this.props.ZipcodeCheck}
                    resetCheckZipcode={this.props.resetCheckZipcode}
                    commercialData={commercialData}
                    validateBasicInfo={this.validateBasicInfo}
                    setLoader={this.toggleLoader}
                    setCommercialData={this.setCommercialData}
                    CommercialProposal={this.props.CommercialProposal}
                    setZipCode={this.setZipCode}
                  />
                  <div className={`adetail ${zipcodeCheck ? '' : 'disabled'}`}>
                    <h3>Community Information</h3>
                    <div className="form-group">
                      <div className="frow">
                        <h4>What is you role in community?</h4>
                        <div className="oplist">
                          {communityRoleData?.map(this.renderCommunityRole)}
                        </div>
                      </div>
                      <div className="frow">
                        <h4>How would you like us to reach out to you? <small>(select all that apply)</small></h4>
                        <div className="oplist">
                          {preferredContactData?.map(this.renderPreferredContact)}
                        </div>
                      </div>
                      <div className="frow">
                        <h4>{`What's in your community?`}</h4>
                        <div className="oplist">
                          {communityTypeData?.map(this.renderType)}
                        </div>
                      </div>
                      <div className="frow">
                        <div className="half-fitem fitem">
                          <div className="half-fitem fitem">
                            <Select
                              placeholder={"How many homes are there in the community?"}
                              showArrow={true}
                              disabled={!zipcodeCheck}
                              name="home_count"
                              onChange={(e) => this.onTextChange({ target: { name: 'home_count', value: e } })}
                              value={home_count || undefined}
                              virtual={false}
                            >
                              <Option value="1-100">1-100</Option>
                              <Option value="101-350">101-350</Option>
                              <Option value="351-500">351-500</Option>
                              <Option value="501+">501+</Option>
                            </Select>
                          </div>
                          <div className="half-fitem fitem position-relative">
                            <input
                              name={"image"}
                              type="file"
                              accept="application/pdf"
                              ref={(ref) => this.upload = ref}
                              style={{ "display": "none" }}
                              onChange={(e) => this.onCommunityImageChange(e)}
                            />
                            <input
                              name="community_map"
                              type="text"
                              className={!zipcodeCheck ? 'disable' : ''}
                              disabled={!zipcodeCheck}
                              placeholder={'Community boundary map'}
                              value={communityBoundaryMap?.name || ''}
                              readOnly={true}
                              onClick={() => this.upload.click()}
                            />
                            <CameraOutlined style={{position: "absolute", alignSelf: "center", right: "10px", top: "13px"}}/>
                            {errors['communityBoundaryMap'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors['communityBoundaryMap']}</label> : ''}
                          </div>
                        </div>
                      </div>

                      <div className={"frow flex"}>
                        <div className="fitem-check flex-1">
                          <input
                            type="checkbox"
                            disabled={!zipcodeCheck}
                            className="fitem-ck-input"
                            id={`is_proposal`}
                            name={`is_proposal`}
                            checked={is_proposal}
                            onChange={(e) => this.onTextChange({ target: { name: 'is_proposal', value: e.target.checked } })}
                          />
                          <label htmlFor={`is_proposal`} className="fitem-ck-txt">
                            {`I'm looking for a proposal`}
                          </label>
                        </div>
                        <div className="fitem-check flex-1">
                          <input
                            type="checkbox"
                            disabled={!zipcodeCheck}
                            className="fitem-ck-input"
                            id={`more_info`}
                            name={`more_info`}
                            checked={more_info}
                            onChange={(e) => this.onTextChange({ target: { name: 'more_info', value: e.target.checked } })}
                          />
                          <label htmlFor={`more_info`} className="fitem-ck-txt">
                            {`I would like more information regarding this service`}
                          </label>
                        </div>
                      </div>
                    </div>

                    {is_proposal ? <div className="frow">
                      <h4>{`What date is your proposal due?`}</h4>
                      <div className="date_list_wrapper date-width">
                        <DatePicker
                          inputReadOnly
                          disabled={!zipcodeCheck}
                          mode={'date'}
                          className='preferred_date_picker selected_date add_quote_datepicket'
                          placeholder='Choose Date'
                          format={"ddd, MMM DD YYYY"}
                          dropdownClassName='current_month'
                          value={proposalDate ? moment(proposalDate) : null}
                          onChange={(e) => this.onTextChange({ target: { name: 'proposalDate', value: e ? e.format('YYYY-MM-DD') : null } })}
                        />
                      </div>
                    </div> : ''}

                    {is_proposal ? <div className="frow md-label">
                      <h4>{`Sample address in the community`}</h4>
                      <div>
                        <div className="google_search_place mb-10">
                          <Script
                            url={`https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_PLACE_API_KEY}&libraries=places`}
                            onLoad={() => window.requestAnimationFrame(this.handleScriptLoad)}
                          />

                          <input
                            autoComplete="off"
                            type="text"
                            ref="address"
                            className={(!zipcodeCheck || is_address_manually) ? 'google_search_disable form--control' : 'form--control'}
                            placeholder="Search for address"
                            name="google_address"
                            id="google_address"
                            onChange={(e) => {
                              if (!e.target.value) {
                                this.setState({
                                  address: { address: '', state: '', city: '', zip_code: '', route: '', street_number: '' },
                                })
                              }
                            }}
                            disabled={!zipcodeCheck || is_address_manually}
                          />
                          <b>or <a href="/" onClick={(e) => {
                            e.preventDefault();
                            this.setState({
                              is_address_manually: true,
                              address: { address: '', state: '', city: '', zip_code: '', route: '', street_number: '' },
                            }, () => {
                              if (this.refs['address']) {
                                this.refs['address'].value = '';
                              }
                              // this.validate()
                            })
                          }}><u>enter address manually</u></a></b>

                        </div>
                        {
                          is_address_manually &&
                          <div className="manually_address">
                            <a href="/#" onClick={(e) => {
                              e.preventDefault();
                              this.setState({
                                is_address_manually: false,
                                address: { address: '', state: '', city: '', zip_code: '', route: '', street_number: '' },
                              })
                            }}><img src={cross_icon} alt="" className="float-right mb-10" /></a>
                            <br />

                            <div className="form-group mb-20">
                              <div className="fitem">
                                <input
                                  type="text"
                                  disabled={!zipcodeCheck}
                                  placeholder="Address"
                                  name="address"
                                  value={address?.address}
                                  onChange={(e) => this.onAddressChanged(e)}
                                />
                              </div>
                              <div className="half-fitem fitem">
                                <div className="half-fitem fitem">
                                  <input
                                    type="text"
                                    disabled={!zipcodeCheck}
                                    placeholder="City"
                                    name="city"
                                    value={address?.city}
                                    onChange={(e) => this.onAddressChanged(e)}
                                  />
                                </div>
                                <div className="half-fitem fitem">
                                  <Select
                                    showArrow={true}
                                    disabled={!zipcodeCheck}
                                    name="state"
                                    placeholder="State"
                                    onChange={(value) => this.onAddressChanged({ target: { name: 'state', value: value } })}
                                    value={address?.state || undefined}
                                    virtual={false}
                                  >
                                    {this.renderAllState()}
                                  </Select>
                                </div>
                                <div className="half-fitem fitem">
                                  <input
                                    type="text"
                                    disabled={!zipcodeCheck}
                                    className='form--control'
                                    placeholder="ZIP Code"
                                    name="zip_code"
                                    maxLength={5}
                                    minLength={5}
                                    onChange={(e) => this.onNumericInputChange(e.target.value) && this.onAddressChanged(e)}
                                    value={address?.zip_code || ''}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        }
                      </div>
                      {(errors?.['address.address'] || errors?.['address.city'] || errors?.['address.state'] || errors?.['address.zip_code'])
                        ? <label className="new_err_msg"><i className="las la-info-circle"/>{'Please enter valid address'}</label> : ''}
                    </div> : ''}

                    <hr />
                    <ServiceInfo
                      ref={(ref) => this.serviceInfo = ref}
                      validateServiceInfo={this.validateServiceInfo}
                      setCommercialData={this.setCommercialData}
                      commercialData={commercialData}
                    />
                  </div>
                </div>
                <SideBar commercialData={commercialData} />
              </div>
              <div className="fix-btn-grp">
                <button className="btn btn-white" onClick={() => this.props.history.goBack()}>Cancel</button>
                {isEdit ? <button className={`btn btn-warning`}  disabled={is_btn_active} onClick={() => this.validate('edit')}>Update Proposal</button>
                  : <button className={`btn btn-warning`} disabled={is_btn_active} onClick={() => this.validate('save')}>Save New Proposal</button>}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default AddQuote;